import { Component, Inject } from '@angular/core';
import { RmsFilePreviewComponent } from '../../../../../../custom-modules/rms-module/rms-file-preview/rms-file-preview.component';
import { RMS_PULLDOWN_DATA } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-receipt-viewer',
  imports: [RmsFilePreviewComponent],
  templateUrl: './receipt-viewer.component.html',
  styleUrl: './receipt-viewer.component.scss'
})
export class ReceiptViewerComponent {
  Path: string;

  constructor(@Inject(RMS_PULLDOWN_DATA) data: any) {
    this.Path = data?.path;
  }
}
